import { TRANSFERS_BLOTTER_PREFIX } from '@src/containers/Blotters/Transfers/tokens';
import { shouldRunBlotterTabsMigration } from '../../blotterTabsMigrationVersion';
import { migrateLegacyTabsIntoTradingBlotterPanels } from '../blotterTabsMigrationHelpers';
import type { AppConfigStateWithLegacyLayoutConfigs } from '../legacyLayoutConfigs.types';

/** Moves legacy transfers tabs into transfers blotter panel params. */
export function migrateTransfersBlotterTabsToPanelParams(initialConfig: unknown) {
  const config = initialConfig as AppConfigStateWithLegacyLayoutConfigs;
  if (!shouldRunBlotterTabsMigration(config)) {
    return;
  }
  const legacyTransfersTabs = config.tabs?.[TRANSFERS_BLOTTER_PREFIX];
  if (legacyTransfersTabs == null) {
    return;
  }

  migrateLegacyTabsIntoTradingBlotterPanels(config, {
    legacyTabs: legacyTransfersTabs,
    blotterType: 'transfersBlotter',
  });
}
